import React from "react"
import { OutboundLink } from "gatsby-plugin-google-analytics"
import Layout from "../components/layout"
import SubheaderFinance from "../components/subheader-finance"
import Products from "../components/products"
import Packages from "../components/packages"
import SellBlock from "../components/sell-block"
import GenericHero from "../components/generic-hero"
import SEO from "../components/seo"
import Imgix from "react-imgix"
import { Background } from "react-imgix"
import InstallBlock from "../components/install-block"
import SubheaderCovid from "../components/subheader-covid"

import house from "../images/experiences/house.png"

import shield from "../images/monitoring/shield.svg"
import shieldLight from "../images/monitoring/shield-light.svg"
import shieldLightCamera from "../images/monitoring/shield-light-camera.svg"

import check from "../images/monitoring/check.svg"
import dash from "../images/monitoring/dash.svg"
import tag from "../images/monitoring/tag.svg"



class Gizmo extends React.Component {
  constructor(props) {
    super(props)
    this.state = { active: "welcome" }
    if (typeof window !== 'undefined') {
      const fragment = window.location.hash.substr(1)
      if (!!fragment) {
        this.state = { active: window.location.hash.substr(1) }
      }
    }
    this.handleControl = this.handleControl.bind(this)
    this.showTags = this.showTags.bind(this)
  }

  componentDidMount() {
    const { active } = this.state
    this.tagElements = document.querySelector(".gizmo .tags")
    this.tags = {
      welcome: Array.prototype.slice.call(this.tagElements.querySelectorAll(".welcome")),
      bed: Array.prototype.slice.call(this.tagElements.querySelectorAll(".bed")),
      heading: Array.prototype.slice.call(this.tagElements.querySelectorAll(".heading")),
      two: Array.prototype.slice.call(this.tagElements.querySelectorAll(".two")),
    }
    this.controls = document.querySelectorAll(".gizmo__controls .control")

    const initialGroup = "welcome"

    let initial = this.tags[initialGroup]

    const keys = Object.keys(this.tags)
    if (keys.indexOf(active) != -1) {
      initial = this.tags[active]
    }

    if (typeof window !== 'undefined' && ("onhashchange" in window)) {
      window.onhashchange = () => {
        let name = window.location.hash.substr(1)
        if (!name) { // if nothing, use the default
          name = initialGroup
        }
        this.setState({
          active: name,
        })
        this.showTags(name)
      }
    }

    let timer = 500
    const delta = 1000 / initial.length
    initial.map((e) =>
      setTimeout(() => e.classList.add("show"), (timer += delta)),
    )
  }

  componentWillUnmount() {
    window.onhashchange = () => {}
  }

  handleControl(name) {
    this.setState({
      active: name,
    })

    this.showTags(name)

    if (typeof window !== "undefined") {
      history.pushState(null, null, `#${name}`)
    }
  }

  showTags(name) {
    const keys = Object.keys(this.tags)

    // hide all of them
    keys.map(k => {
      this.tags[k].map((e) => e.classList.remove("show"))
    })

    // only show the group we mean to
    if (keys.indexOf(name) != -1) {
      this.tags[name].map((e) => e.classList.add("show"))
    }
  }

  render() {
    const { active } = this.state
    return (
      <>
       <div className="gizmo__controls">
          <div className="controls">
            <div
              className={`control t7 ${active == "welcome" ? "active" : ""}`}
              onClick={() => this.handleControl("welcome")}
            >
              Welcome Home
            </div>
            <div
              className={`control t7 ${active == "bed" ? "active" : ""}`}
              onClick={() => this.handleControl("bed")}
            >
              Time For Bed
            </div>
            <div
              className={`control t7 ${active == "heading" ? "active" : ""}`}
              onClick={() => this.handleControl("heading")}
            >
              Heading Out
            </div>
            <div
              className={`control t7 ${active == "two" ? "active" : ""}`}
              onClick={() => this.handleControl("two")}
            >
               Eyes and Ears
            </div>
          </div>
        </div>
        <div className="gizmo">
          <img src={house} />
          <div className="tags">
            <div className="tag welcome heading dimmer right">Plug-in Dimmer</div>
            <div className="tag bed dimmer2 right">Plug-in Dimmer x2</div>
            <div className="tag welcome bed heading thermostat left">Smart Thermostat</div>
            <div className="tag welcome bed heading two motion left">Motion Sensor</div>
            <div className="tag welcome bed heading two window left">Window Sensor</div>
            <div className="tag welcome bed heading two touchscreen left">Touchscreen Panel</div>
            <div className="tag welcome bed heading two door right">Smart Door Lock</div>
            <div className="tag bed temp right">Tempurature Sensor</div>
            <div className="tag bed heading garage right">Garage Door Opener</div>
            <div className="tag heading two smoke left">Smoke Detector</div>
            <div className="tag heading wifi right">Wifi Indoor Camera</div>
            <div className="tag two bulb left">Smart LED Lightbulb</div>
            <div className="tag two doorbell left">Video Doorbell</div>
          </div>
        </div>
      </>
    )
  }
}

const ExperiencesPage = () => {
  return (
    <Layout className="experiences" headerSeparator>
      <SEO title="Smart Home Systems" />
      <SubheaderFinance
        title="Packages from "
        price="$16.99/mo"
        link="http://d2eb8hz387zjm2.cloudfront.net/popular/#packages"
      />
      <div className="hero">
        <h1 className="experiences-header">Streamline your daily routine</h1>
        <Gizmo />
      </div>
      {/* <div className="subhero__container">
        <div className="subhero">
          <h2 className="t11 t11--loose">
            Explore our experience-based packages, built to streamline your daily routines and make your life brighter.
          </h2>
        </div>
      </div> */}

      <div className="categories">
        <div className="category category--reverse">
          <div className="image">
            <Imgix
              src="https://brightsuite.imgix.net/experiences/experiences-welcome-home.jpg"
              height={500}
              width={625}
              imgixParams={{
                fit: "crop",
                crop: "focalpoint",
                "fp-x": 0.1,
                "fp-y": 0.6,
              }}
            />
          </div>
          <div className="info">
            <div className="info__header t11">Welcome Home</div>
            <div className="info__desc t5 t5--loose">
            No matter if you’re tired or have your hands full, we’re here to help welcome you home.
            When you approach your home, your BrightSuite system can:
          </div>
            <ul className="info__list">
              <li>Adjust your house temperature</li>
              <li>Unlock your front door</li>
              <li>Disarm the security system</li>
              <li>Turn on foyer lights</li>
              <li>Play your favorite playlist with Sonos®</li>
            </ul>
            <OutboundLink className="info__cta cta" href="https://shop.brightsuite.com/welcome-home">
              Buy Now
            </OutboundLink>
          </div>
        </div>
        <div className="category">
          <div className="image">
            <Imgix
              src="https://brightsuite.imgix.net/experiences/experiences-time-for-bed.jpg"
              height={500}
              width={625}
              imgixParams={{
                fit: "crop",
                crop: "focalpoint",
                "fp-x": 0.1,
                "fp-y": 0.6,
              }}
            />
          </div>
          <div className="info">
            <div className="info__header t11">Time For Bed</div>
            <div className="info__desc t5 t5--loose">
            Have you ever asked yourself the question after getting in bed, “Did I lock the front door?” From curling up on the couch for a movie to getting ready for a good night’s rest, one button or a few spoken words gets you and your home comfortable.
            </div>
            <ul className="info__list">
              <li>Lock doors and close garage door</li>
              <li>Turn off bedroom lights</li>
              <li>Turn thermostat down for a peaceful sleep</li>
              <li>Set target temperature for your bedroom</li>
              <li>Play white noise from your Sonos®</li>
            </ul>
            <OutboundLink className="info__cta cta" href="https://shop.brightsuite.com/time-for-bed">
              Buy Now
            </OutboundLink>
          </div>
        </div>
        <div className="category category--reverse">
          <div className="image">
            <Imgix
              src="https://brightsuite.imgix.net/experiences/experiences-heading-out.jpg"
              height={500}
              width={625}
            />
          </div>
          <div className="info">
            <div className="info__header t11">Heading Out</div>
            <div className="info__desc t5 t5--loose">
            Who doesn’t have a checklist of things they run through every time they leave their home? Buttons to flip, things to turn off/down. We take care of this so you can get out the door and on with the important things in your life. As you’re walking out, one button press will:
            </div>
            <ul className="info__list">
              <li>Turn off lights</li>
              <li>Set thermostat to save energy</li>
              <li>Lock your front door</li>
              <li>Arm your security system</li>
              <li>Notifies you and emergency services of fire or flood</li>
            </ul>
            <OutboundLink className="info__cta cta" href="https://shop.brightsuite.com/heading-out">
              Buy Now
            </OutboundLink>
          </div>
        </div>
        <div className="category">
          <div className="image">
            <Imgix
              src="https://brightsuite.imgix.net/experiences/experiences-eyes-and-ears.jpg"
              height={500}
              width={625}
            />
          </div>
          <div className="info">
            <div className="info__header t11">Eyes and Ears</div>
            <div className="info__desc t5 t5--loose">
            Let a friend in, make sure a package is safely delivered, or be notified if someone approaches your front porch. You now have complete control of your front door, no matter where you might be:
            </div>
            <ul className="info__list">
              <li>Motion sensor lights</li>
              <li>Speak to visitors with doorbell camera</li>
              <li>Unlock and lock doors after entrance</li>
            </ul>
            <OutboundLink className="info__cta cta" href="https://shop.brightsuite.com/eyes-ears">
              Buy Now
            </OutboundLink>
          </div>
        </div>
      </div>

      <Packages
        omit="experience"
      />
      <InstallBlock />
    </Layout>
  )
}

export default ExperiencesPage
